export default __webpack_public_path__ + "static/media/logo.cea383a0.svg";